<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <StaticInfoForm :baseStaticInfo="staticInfo" :basestaticInfoName="name" :loading="loading" @submit-requested="submitRequested"></StaticInfoForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import StaticInfoForm from '@/views/StaticInfos/StaticInfoForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                staticInfo: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { StaticInfoForm },
        computed:
        {
            ...mapState('staticInfos', ['getStaticInfoByIDOutput']),
        },
        methods: {
            ...mapActions('staticInfos', ['getStaticInfoByID']),
            ...mapActions('staticInfos', ['putStaticInfo']),
            submitRequested(staticInfo) {
                this.putStaticInfo(staticInfo);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({ path: '/staticInfos/list' });
            }
            else {
                this.getStaticInfoByID(this.$route.query.id);
            }
        },
        watch:
        {
            getStaticInfoByIDOutput: function (output) {
                if (!output && !output.data) {
                    router.push({ path: '/staticInfos/list' });
                }
                else {
                    this.staticInfo = output.data;
                    this.loading = false;
                }
            }
        }
    }
</script>